import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionItem } from '../interfaces/collection-item.interface';
import { FoldersResponse } from '../interfaces/folders-response.interface';
import { HttpClient } from '@angular/common/http';
import { IdentityService } from '../../../../services/identity.service';
import { environment } from '../../../../../environments/environment';
import { CreateFolderData } from '../interfaces/create-folder-data.interface';
import { ProcessedNode } from '../interfaces/processed-node.interface';
import { MovedItems } from '../interfaces/move-items.interface';

@Injectable({
  providedIn: 'root',
})

export class FoldersService {
  readonly httpClient = inject(HttpClient);
  readonly identityService = inject(IdentityService);

  get companySlug(): string {
    return this.identityService.companySlug;
  }

  get baseFoldersUrl(): string {
    return `${environment.adminApi}/companies/${this.companySlug}/folders`;
  }

  get(): Observable<FoldersResponse<CollectionItem>> {
    let url = this.baseFoldersUrl;

    if (this.identityService.isTeamAdmin()) {
      const teamSlug = this.identityService.teamSlug;
      url = `${environment.adminApi}/companies/${this.companySlug}/teams/${teamSlug}/folders`;
    }

    return this.httpClient.get<FoldersResponse<CollectionItem>>(url);
  }

  create(createFolderData: CreateFolderData): Observable<Partial<CollectionItem>> {
    return this.httpClient.post<Partial<CollectionItem>>(this.baseFoldersUrl, createFolderData);
  }

  edit(id: string, changes: Pick<ProcessedNode, 'Name'>): Observable<Partial<CollectionItem>> {
    return this.httpClient.put<Partial<CollectionItem>>(`${this.baseFoldersUrl}/${id}`, changes);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseFoldersUrl}/${id}`);
  }

  move(movedItems: MovedItems): Observable<void> {
    return this.httpClient.put<void>(`${this.baseFoldersUrl}/move`, movedItems);
  }
}
